'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadBluetoothError = exports.updateClientStatus = exports.trackDevice = exports.sendHeartrate = exports.leaveClass = exports.joinClass = exports.UPDATE_CLIENT_STATUS = exports.TRACK_DEVICE_INFO = exports.BLUETOOTH_DEVICE_ERROR = exports.SEND_HEARTRATE = exports.LEAVE_CLASS = exports.JOIN_CLASS = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.doJoinClass = doJoinClass;
exports.doLeaveClass = doLeaveClass;
exports.doSendHeartrate = doSendHeartrate;
exports.doTrackDevice = doTrackDevice;
exports.doUpdateClientStatus = doUpdateClientStatus;
exports.watchBluetooth = watchBluetooth;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _bluetooth = require('constants/bluetooth');

var _bluetooth2 = _interopRequireDefault(_bluetooth);

var _video = require('redux/modules/video');

var _pusher = require('features/VideoDetail/sagas/pusher.saga');

var _helpers = require('redux/saga/helpers');

var _videos = require('redux/saga/selectors/videos');

var _multitrack = require('helpers/multitrack');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doJoinClass),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doLeaveClass),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doSendHeartrate),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doTrackDevice),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(doUpdateClientStatus),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchBluetooth); /* eslint-disable camelcase */

var JOIN_CLASS = exports.JOIN_CLASS = 'JOIN_CLASS';
var LEAVE_CLASS = exports.LEAVE_CLASS = 'LEAVE_CLASS';
var SEND_HEARTRATE = exports.SEND_HEARTRATE = 'SEND_HEARTRATE';
var BLUETOOTH_DEVICE_ERROR = exports.BLUETOOTH_DEVICE_ERROR = 'BLUETOOTH_DEVICE_ERROR';
var TRACK_DEVICE_INFO = exports.TRACK_DEVICE_INFO = 'TRACK_DEVICE_INFO';
var UPDATE_CLIENT_STATUS = exports.UPDATE_CLIENT_STATUS = 'UPDATE_CLIENT_STATUS';

var joinClass = exports.joinClass = function joinClass(alias, userMode) {
  return { type: JOIN_CLASS, alias: alias, userMode: userMode };
};
var leaveClass = exports.leaveClass = function leaveClass(alias) {
  return { type: LEAVE_CLASS, alias: alias };
};
var sendHeartrate = exports.sendHeartrate = function sendHeartrate(bpm, classId, playhead) {
  return {
    type: SEND_HEARTRATE, bpm: bpm, classId: classId, playhead: playhead
  };
};
var trackDevice = exports.trackDevice = function trackDevice(payload) {
  return { type: TRACK_DEVICE_INFO, payload: payload };
};
var updateClientStatus = exports.updateClientStatus = function updateClientStatus(alias, status) {
  return { type: UPDATE_CLIENT_STATUS, alias: alias, status: status };
};
var loadBluetoothError = exports.loadBluetoothError = _helpers.errorActionCreator.bind(null, BLUETOOTH_DEVICE_ERROR);

function doJoinClass(client, _ref) {
  var alias = _ref.alias,
      _ref$userMode = _ref.userMode,
      userMode = _ref$userMode === undefined ? 'INTERACTIVE' : _ref$userMode;

  var _ref2, _ref3, user, join;

  return _regenerator2.default.wrap(function doJoinClass$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client])].concat((0, _toConsumableArray3.default)(userMode !== 'NON_INTERACTIVE' ? [(0, _effects.put)((0, _video.updateDevice)({
            enabled: true,
            status: _bluetooth2.default.DEVICE_CONNECTED
          }))] : [])));

        case 3:
          _ref2 = _context.sent;
          _ref3 = (0, _slicedToArray3.default)(_ref2, 1);
          user = _ref3[0];
          _context.next = 8;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.leaderboardJoinClass, [client, alias, {
            user_id: user.id,
            user_mode: ['INTERACTIVE', 'NON_INTERACTIVE'].indexOf(userMode) > -1 ? userMode : 'NON_INTERACTIVE'
          }]);

        case 8:
          join = _context.sent;
          _context.next = 11;
          return (0, _effects.put)((0, _pusher.initPusherChannel)(join.configuration.channel_name));

        case 11:
          _context.next = 13;
          return (0, _effects.call)(_multitrack.ec, 'Leaderboard activity', {
            description: 'join class'
          });

        case 13:
          _context.next = 21;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context['catch'](0);
          _context.next = 19;
          return (0, _effects.call)(_multitrack.ec, 'Leaderboard error', {
            description: 'failed to join class',
            error: _context.t0
          });

        case 19:
          _context.next = 21;
          return (0, _effects.put)((0, _video.updateDevice)({ status: _bluetooth2.default.DEVICE_FAILED }));

        case 21:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 15]]);
}

function doLeaveClass(client, _ref4) {
  var alias = _ref4.alias;
  var user;
  return _regenerator2.default.wrap(function doLeaveClass$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 3:
          user = _context2.sent;
          _context2.next = 6;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.leaderboardLeaveClass, [client, alias, { user_id: user.id }]);

        case 6:
          _context2.next = 8;
          return (0, _effects.call)(_multitrack.ec, 'Leaderboard activity', {
            description: 'leave class'
          });

        case 8:
          _context2.next = 14;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 14;
          return (0, _effects.call)(_multitrack.ec, 'Leaderboard error', {
            description: 'failed to leave class',
            error: _context2.t0
          });

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 10]]);
}

function doSendHeartrate(client, _ref5) {
  var bpm = _ref5.bpm,
      classId = _ref5.classId,
      playhead = _ref5.playhead;

  var joined, classEnded, _ref6, _ref6$calories, calories, disconnected, heart_rate, max_heart_rate, points;

  return _regenerator2.default.wrap(function doSendHeartrate$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.select)(_videos.leaderboardJoin, classId);

        case 3:
          joined = _context3.sent;
          _context3.next = 6;
          return (0, _effects.select)(_videos.videoCompleted);

        case 6:
          classEnded = _context3.sent;

          if (!(joined && !classEnded)) {
            _context3.next = 21;
            break;
          }

          _context3.next = 10;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.leaderboardUpdateHeartrate, [client, classId, { heart_rate: bpm, playhead_time: playhead }]);

        case 10:
          _ref6 = _context3.sent;
          _ref6$calories = _ref6.calories;
          calories = _ref6$calories === undefined ? 0 : _ref6$calories;
          disconnected = _ref6.disconnected;
          heart_rate = _ref6.heart_rate;
          max_heart_rate = _ref6.max_heart_rate;
          points = _ref6.points;
          _context3.next = 19;
          return (0, _effects.put)((0, _video.updateDevice)({
            bpm: joined ? heart_rate : bpm,
            bpmPercent: heart_rate / (max_heart_rate || 190) * 100,
            calories: calories,
            disconnected: disconnected,
            points: parseInt(points, 10)
          }));

        case 19:
          _context3.next = 23;
          break;

        case 21:
          _context3.next = 23;
          return (0, _effects.put)((0, _video.updateDevice)({
            bpm: bpm
          }));

        case 23:
          _context3.next = 29;
          break;

        case 25:
          _context3.prev = 25;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 29;
          return (0, _effects.call)(_multitrack.ec, 'Leaderboard error', {
            description: 'failed to patch heart rate',
            error: _context3.t0
          });

        case 29:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 25]]);
}

function doTrackDevice(client, _ref7) {
  var payload = _ref7.payload;
  return _regenerator2.default.wrap(function doTrackDevice$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntity, _bound.fitnessDeviceTracking, [client, payload]), (0, _effects.put)((0, _video.updateDevice)({
            connection: payload.device_name
          }))]);

        case 3:
          _context4.next = 9;
          break;

        case 5:
          _context4.prev = 5;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 9;
          return (0, _effects.put)(loadBluetoothError(_context4.t0));

        case 9:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 5]]);
}

function doUpdateClientStatus(client, _ref8) {
  var alias = _ref8.alias,
      status = _ref8.status;
  return _regenerator2.default.wrap(function doUpdateClientStatus$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.leaderboardUpdateClientStatus, [client, alias, {
            event_name: status,
            platform: 'web'
          }]);

        case 3:
          _context5.next = 9;
          break;

        case 5:
          _context5.prev = 5;
          _context5.t0 = _context5['catch'](0);
          _context5.next = 9;
          return (0, _effects.put)(loadBluetoothError(_context5.t0));

        case 9:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[0, 5]]);
}

function watchBluetooth(client) {
  return _regenerator2.default.wrap(function watchBluetooth$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, JOIN_CLASS, doJoinClass, client);

        case 2:
          _context6.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, LEAVE_CLASS, doLeaveClass, client);

        case 4:
          _context6.next = 6;
          return (0, _effects.fork)(_effects.takeEvery, SEND_HEARTRATE, doSendHeartrate, client);

        case 6:
          _context6.next = 8;
          return (0, _effects.fork)(_effects.takeEvery, TRACK_DEVICE_INFO, doTrackDevice, client);

        case 8:
          _context6.next = 10;
          return (0, _effects.fork)(_effects.takeEvery, UPDATE_CLIENT_STATUS, doUpdateClientStatus, client);

        case 10:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}